import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

export function hsGenerateLineSegmentGeometryData(): HsRegularGeometryData {
  return new HsRegularGeometryData([0, 0, 0, 1, 0, 0], []);
}
